import { useCallback, useEffect } from 'react';

const useDatePickerFocusHandler = (
  datepickerRef: React.RefObject<any>,
) => {
  const isCalendarOpen = datepickerRef.current?.isCalendarOpen?.();
  const handleFocusChange = useCallback(() => {
    if (isCalendarOpen && !document.activeElement.closest('.nv-date-picker')) {
      datepickerRef.current?.setOpen(false);
    }
  }, [isCalendarOpen, datepickerRef]);

  useEffect(() => {
    document.addEventListener('focusin', handleFocusChange);
    return () => {
      document.removeEventListener('focusin', handleFocusChange);
    };
  }, [handleFocusChange]);
};

export default useDatePickerFocusHandler;
